import { Component } from '@angular/core';
import { ResearchMemberProfileEntity } from 'mj_generatedentities';
import { RegisterClass } from '@memberjunction/global';
import { BaseFormComponent } from '@memberjunction/ng-base-forms';

@RegisterClass(BaseFormComponent, 'Member Profiles') // Tell MemberJunction about this class
@Component({
    standalone: false,
    selector: 'gen-researchmemberprofile-form',
    templateUrl: './researchmemberprofile.form.component.html'
})
export class ResearchMemberProfileFormComponent extends BaseFormComponent {
    public record!: ResearchMemberProfileEntity;

    override async ngOnInit() {
        await super.ngOnInit();
        this.initSections([
            { sectionKey: 'details', sectionName: 'Details', isExpanded: true }
        ]);
    }
}

